const WageCalcHelper = {
  cleanCountyString(value, state) {
    let countyLabel = value;
    if (value.includes("-")) {
      let countyAreaJoinIndex = value.indexOf(" - ");
      countyLabel = value.toUpperCase().slice(0, countyAreaJoinIndex);
    } else {
      countyLabel = value.toUpperCase();
    }

    if (countyLabel.includes(".")) {
      countyLabel = countyLabel.replace(".", "");
    }

    return countyLabel;
  },

  socCodeCheck(value) {
    let rdFlag = undefined;
    if (value) {
      let socPrefix = value.substring(0, 2);
      //xwalk soc R&D fields
      if (socPrefix != "15" && socPrefix != "17") {
        rdFlag = false;
      }
    }
    return rdFlag;
  },

  setAreaBasedOn(level) {
    let obj = {
      "BLS Area": "bls_area",
      "County/Township": "county_town",
    };
    return obj[level];
  },

  setCollectionType(type) {
    let obj = {
      "All Industries": "alc",
      "ACWIA Higher Education": "edc_acwia",
    };
    if (!obj.hasOwnProperty(type)) {
      return type;
    }
    return obj[type];
  },

  fieldsFilled(state) {
    let secondaryCountyCheck = true;
    if (state.OES_area_based == "BLS Area" && state.OES_area !== "") {
      if (!state.OES_secondary_county) {
        secondaryCountyCheck = false;
      }
    }

    return !(
      state.OES_state &&
      state.OES_date_source &&
      state.OES_collection_type &&
      state.OES_area_based &&
      state.OES_area &&
      state.OES_soc_code &&
      state.OES_soc_title &&
      state.OES_rd_flag !== undefined &&
      secondaryCountyCheck
    );
  },
};

export default WageCalcHelper;
